import { take, fork, put, call, select } from 'redux-saga/effects';

import { apiGet } from './callApi';
import { transformGamesData } from './helpers/transform';

import actionTypes from '../actionTypes';
import { getToken } from '../selectors';
import {
  successFreespinsGames,
  failFreespinsWageringGames,
} from '../actionCreators/freespinsWageringGames';

import apiRoutes from '../../constants/apiRoutes';

function* getGames(): any {
  try {
    const headers = {};
    headers['x-access-token'] = yield select(getToken);
    const params = {
      device: window.innerWidth < 580 ? 'mobile' : 'desktop',
    };
    const response = yield call(apiGet, 'REACT_APP_REMOTE_URL', apiRoutes.GET_FREESPINS_WAGERING_GAMES, params, headers);
    if (response?.data?.success) {
      let freespinsGames = {};

      response.data.result.map((el: { wageringMissionId: string | number; combinedGames: { freespinsGames: { [x: string]: { [x: string]: any } } } }) => {
        freespinsGames[el.wageringMissionId] = {
          games: transformGamesData(el.combinedGames.freespinsGames, 'casino')?.games,
          providers: transformGamesData(el.combinedGames.freespinsGames, 'casino')?.providers,
        };
      });

      yield put(successFreespinsGames(freespinsGames));
    } else {
      yield put(failFreespinsWageringGames());
    }

  } catch (e) {
    yield put(failFreespinsWageringGames(e));
  }
}

export function* watchRequestFreespinsWageringGames() {
  while (true) {
    yield take(actionTypes.FREESPINS_WAGERING_GAMES_REQUEST);
    yield fork(getGames);
  }
}
